import React from 'react';

const BigButton = ({ onClick, children, disabled=false }) => {
  return (
    <button
      className="btn btn-large waves-effect waves-light col m4 hoverable"
      style={{
        width: "100%",
        borderRadius: "3px",
        letterSpacing: "1.5px",
        marginRight: "2px",
        marginLeft: "2px",
        float: "right",
      }}
      onClick={onClick}
      disabled={disabled}
    >
      {children}
    </button>
  );
};

export default BigButton;